import { Card, Label } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

type LabeledCardProps = {
  disabled?: boolean;
  children: React.ReactNode;
  cardClassName?: string;
  label: string;
  labelClassName: string;
  onClick?: () => void;
  testId?: string;
};

export const LabeledCard: React.VFC<LabeledCardProps> = ({
  children,
  cardClassName,
  disabled,
  labelClassName,
  label,
  onClick,
  testId,
}) => (
  <Label
    className={classNames(labelClassName, 'sd-labeled-card-container', {
      'sd-labeled-card-container--disabled': disabled,
    })}
    onClick={(e) => {
      // otherwise clicking the card will always trigger inputs such as file inputs
      // because labels are weird
      e.preventDefault();
    }}
  >
    {label}
    <Card
      className={cardClassName}
      data-testid={testId}
      onClick={disabled ? undefined : onClick}
    >
      {children}
    </Card>
  </Label>
);
